<template>
  <p>Oops... unable to initate account linking</p>
</template>

<script>
import { isValidClient, isValidRedirectURI } from "./js/helper";

export default {
  name: "GoogleAssistantLinkAccount",
  created() {
    console.log("LINK ACCOUNT PARAMS", this.$route.query);
    var clientId = this.$route.query.client_id;
    var redirectURI = this.$route.query.redirect_uri;
    console.log(clientId, redirectURI);
    if (isValidClient(clientId) && isValidRedirectURI(redirectURI)) {
      console.log("here2");
      this.$cookie.set("link_account_redirect_uri", redirectURI);
      this.$cookie.set("link_account_state", this.$route.query.state);
      this.$cookie.set(
        "link_account_response_type",
        this.$route.query.response_type
      );
      window.location.href = ""; // TODO
    }
  }
};
</script>


// WEBPACK FOOTER //
// GoogleAssistantLinkAccount.vue?214a4577